module.exports = __webpack_public_path__ + "img/3_44.b2ce7b1a.png";